<template>
  <div class="recordMsgPage">
    <van-loading size="24px" vertical v-if="showNonePage"
      >加载中...</van-loading
    >
    <div class="dutyMsg" id="dutyMsg" v-if="!showNonePage">
      <div class="msgList" v-if="this.recordData != ''">
        <ul>
          <li>
            <p class="clearfix">
              <span>责任区面积</span>
              <span>公顷</span>
            </p>
            <p>{{ recordData.gridArea ? recordData.gridArea : 0 }}</p>
            <p>{{ recordData.gridName ? recordData.gridName : "" }}</p>
          </li>
          <li class="foresM">
            <p class="clearfix">
              <span>林地面积</span>
              <span>公顷</span>
            </p>
            <p>
              {{
                recordData.xiaoBanInfoResult == null
                  ? "0"
                  : recordData.xiaoBanInfoResult.xiaoBanArea
              }}
            </p>
            <p class="clearfix">
              <span
                >林地小班
                {{
                  recordData.xiaoBanInfoResult == null
                    ? "0"
                    : recordData.xiaoBanInfoResult.xiaoBanNumber
                }}
                个</span
              >
              <span
                >森林覆盖率
                {{
                  recordData.xiaoBanInfoResult == null
                    ? "0"
                    : recordData.xiaoBanInfoResult.fractionCoverage
                }}
                %</span
              >
            </p>
          </li>
          <li>
            <p class="clearfix">
              <span>湿地面积</span>
              <span>公顷</span>
            </p>
            <p>
              {{
                recordData.shidiInfoResult == null
                  ? "0"
                  : recordData.shidiInfoResult.shiDiArea
              }}
            </p>
            <p>
              <span
                >湿地小班
                {{
                  recordData.shidiInfoResult == null
                    ? "0"
                    : recordData.shidiInfoResult.shiDiNumber
                }}
                个</span
              >
            </p>
          </li>
          <!-- <li class="oldtree" v-if=" this.recordData.gushuList.lenght !=0 "> -->
          <li class="oldtree">
            <p class="clearfix">
              <span>古树名木</span>
              <span>株</span>
            </p>
            <p>
              {{
                recordData.gushuListCount == "" ? 0 : recordData.gushuListCount
              }}
            </p>
            <p class="clearfix">
              <span v-for="(item, index) in recordData.gushuList" :key="index"
                >{{ item.gsDj }}
                {{ item.gsDjNumber ? item.gsDjNumber : "0" }}</span
              >
            </p>
          </li>
          <li>
            <p class="clearfix">
              <span>林长</span>
              <span>个</span>
            </p>
            <p>{{ recordData.lzCount }}</p>
            <p>护林员 {{ recordData.ylyyCount }} 个</p>
          </li>
          <li>
            <p class="clearfix">
              <span>协同单位</span>
              <span>个</span>
            </p>
            <p>{{ recordData.xtdwInfoResult.xtdwCount }}</p>
            <p>
              {{
                recordData.xtdwInfoResult.xtdwCount == "0"
                  ? "暂无"
                  : recordData.xtdwInfoResult.xtdwName
              }}
            </p>
          </li>
        </ul>
        <div class="eChartDataBox">
          <h5>林地</h5>
          <div class="forsetChart barUnit" v-if="this.diData">
            <!-- 地类 -->
            <p>地类</p>
            <span class="units">单位：小班</span>
            <gg-bar-chart :sourceList="diData"></gg-bar-chart>
          </div>
          <div class="woodsChart cicleUnit" v-if="this.woodsData">
            <!-- 森林类别 -->
            <p>森林（林地）类别</p>
            <span class="units">单位：小班</span>
            <gg-cicle-chart :sourceList="woodsData"></gg-cicle-chart>
          </div>
          <div class="gChengChart barUnit" v-if="this.gchengData">
            <!-- 工程类别 -->
            <p>工程类别</p>
            <span class="units">单位：小班</span>
            <gg-bar-chart :sourceList="gchengData"></gg-bar-chart>
          </div>
          <div class="linZChart barUnit" v-if="this.linZData">
            <!-- 工程类别 -->
            <p>林种类别</p>
            <span class="units">单位：小班</span>
            <gg-bar-chart :sourceList="linZData"></gg-bar-chart>
          </div>
          <h5 v-if="this.sDiData">湿地</h5>
          <div class="linZChart barUnit" v-if="this.sDiData">
            <!-- 工程类别 -->
            <p>湿地型</p>
            <span class="units">湿地数量：个</span>
            <gg-bar-chart :sourceList="sDiData"></gg-bar-chart>
          </div>
        </div>
      </div>
      <div class="nonePage" v-if="this.recordData == ''">
        <img :src="nonePng" alt />
        <p>暂无数据</p>
      </div>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import nonePng from "@/assets/none.png";
const ggBarChart = () => import("@/components/common/barChart");
const ggCicleChart = () => import("@/components/common/cicleChart");
export default {
  name: "baseRecord",
  data() {
    return {
      nonePng: nonePng, //默认图片
      showNonePage: true,
      recordData: {
        gridArea: "",
        gridName: "",
        xiaoBanInfoResult: {
          xiaoBanArea: "",
          xiaoBanNumber: "",
          fractionCoverage: "",
          coverageArea: "",
        },
        shidiInfoResult: { shiDiArea: "", shiDiNumber: "" },
        gushuList: [],
        lzCount: "",
        ylyyCount: "",
        xtdwInfoResult: { xtdwCount: "", xtdwName: "" },
      },

      diData: [], //地类
      woodsData: [], //森林类别
      gchengData: [], //工程类别
      linZData: [], //林种类别
      sDiData: [], //湿地类别
    };
  },

  props: {
    userId: { String },
  },
  components: {
    ggBarChart,
    ggCicleChart,
  },
  mounted() {
    this.$nextTick(() => {
      this.initRecord();
    });
  },

  methods: {
    initRecord() {
      let _this = this;
      _this.$api.User.myGridStatistics({
        uid: _this.userId,
      })
        .then((res) => {
          if (res.code == "1") {
            _this.showNonePage = false;

            if (res.data == null || res.data.gridArea == null) {
              _this.recordData = "";
            } else {
              if (res.data.gushuList == 0) {
                _this.$set(_this.recordData, "gushuListCount", 0);
                let data = [
                  {
                    gsDjNumber: 0,
                    gsDj: "古树",
                  },
                  {
                    gsDjNumber: 0,
                    gsDj: "名木",
                  },
                ];
                res.data.gushuList = res.data.gushuList.concat(data);
              } else {
                let count =
                  Number(res.data.gushuList[0].gsDjNumber) +
                  Number(res.data.gushuList[1].gsDjNumber);
                _this.$set(_this.recordData, "gushuListCount", count);
              }
              _this.recordData = Object.assign({}, _this.recordData, res.data);
              _this.initChart();
            }
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    initChart() {
      let _this = this;
      _this.$api.universal.dutyArea
        .gridStatisticalChart({
          objid: _this.recordData.objid,
          zqLevel: _this.recordData.gridLevel,
          zqCode: _this.recordData.zqCode,
          areaType: _this.recordData.areaType,
        })
        .then((res) => {
          if (res.code == "1") {
            console.log(res.data);
            _this.barData = res.data.diLeiList;
            //地类
            if (res.data.diLeiList.length > 0) {
              _this.diData = res.data.diLeiList;
            } else {
              _this.diData = null;
            }
            //森林地类
            if (res.data.senLinLbList.length > 0) {
              _this.woodsData = res.data.senLinLbList;
            } else {
              _this.woodsData = null;
            }
            //工程
            if (res.data.gchengLbList.length > 0) {
              _this.gchengData = res.data.gchengLbList;
            } else {
              _this.gchengData = null;
            }
            //林种
            if (res.data.linZhongList.length > 0) {
              _this.linZData = res.data.linZhongList;
            } else {
              _this.linZData = null;
            }
            //湿地
            if (res.data.shiDiXingList.length > 0) {
              _this.sDiData = res.data.shiDiXingList;
            } else {
              _this.sDiData = null;
            }
          } else {
            console.log(res.msg);
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  watch: {
    userId: function () {
      this.showNonePage = true;
      this.initRecord();
    },
  },
};
</script>
<style lang="less">
.recordMsgPage {
  width: 100%;
  min-height: 100%;
  background-color: #f6f6f6;

  .dutyMsg {
    width: 100%;
    height: 100%;
    padding-top: 8px;
    position: relative;
    .nonePage {
      width: 120px;
      height: 150px;
      position: absolute;
      left: 50%;
      margin-left: -60px;
      top: 50%;
      margin-top: -75px;

      img {
        display: block;
        max-width: 100px;
        max-height: 100px;
        margin: 0 auto;
      }

      p {
        margin-top: 10px;
        text-align: center;
        color: #5c5d5d;
        font-size: 16px;
      }
    }
    .msgList {
      ul {
        margin-bottom: 10px;
        li:first-child {
          margin-top: 0;
        }
        li {
          width: 100%;
          padding: 5px 16px;
          background-color: #fff;
          margin: 8px 0;
          p {
            margin-top: 8px;
            span {
              font-size: 14px;
              color: #999;
            }
          }
          p:first-child {
            span:first-child {
              font-weight: 600;
              float: left;
            }
            span:last-child {
              float: right;
            }
          }
          p:nth-child(2) {
            border-bottom: 1px solid #f4f4f4;
            line-height: 25px;
            color: #4bc985;
            font-size: 16px;
            text-align: left;
            margin: 5px 0;
          }
          p:last-child {
            color: #979696;
            line-height: 20px;
            opacity: 0.6;
            font-size: 14px;
          }
        }

        li.oldtree {
          p:last-child {
            width: 100%;
            span {
              float: left;
            }
            span:last-child {
              float: right;
            }
          }
        }
        li.foresM {
          p:last-child {
            span:first-child {
              float: left;
            }
            span:last-child {
              float: right;
            }
          }
        }
      }
      .eChartDataBox {
        padding: 0 16px;
        background-color: #fff;
        h5 {
          font-size: 18px;
          line-height: 22px;
          color: #666;
        }
        p {
          text-align: center;
          font-size: 16px;
          color: #666;
        }
        .barUnit {
          position: relative;
          .units {
            position: absolute;
            top: 50px;
            left: 0;
            color: #666;
            font-size: 10px;
          }
        }
        .cicleUnit {
          position: relative;
          .units {
            position: absolute;
            top: 60px;
            right: 10px;
            color: #666;
            font-size: 10px;
          }
        }
      }
    }
  }
}
</style>